import { darken } from 'polished'
import styled, { css } from 'styled-components'
import fadeIn from '../../../styles/animations/fadeIn'

interface FieldProps {
  readonly error: boolean
}

export const Container = styled.div`
  ${fadeIn};
  height: 100%;
`

export const FieldColor = styled.input<FieldProps>`
  -webkit-appearance: none;
  font-size: 14px;
  width: 36px;
  height: 36px;
  flex-shrink: 0;
  border-radius: 10px;
  background-color: #efefef;
  color: ${({ theme }) => theme.colors.input};
  font-weight: 600;
  transition: border-color 200ms linear;
  border: none;
  :hover,
  :focus {
    border-color: ${({ theme }) => darken(0.2, theme.colors.border)};
  }

  &::placeholder {
    font-size: 14px;
    font-weight: 500;
    color: ${({ theme }) => darken(-0.6, theme.colors.placeholder)};
  }
  ${({ error }) =>
    error &&
    css`
      border-color: ${({ theme }) => theme.colors.error};

      &:hover {
        border-color: ${({ theme }) => darken(0.2, theme.colors.error)};
      }
    `};
`

export const Content = styled.div<any>`
  position: relative;
  width: fit-content;
  width: 100px;
  padding: 15px;
  border-radius: 10px;
  border: 1px solid ${({ theme }) => theme.colors.secondary};
  display: flex;
  align-items: center;
  flex-direction: column;
  gap: 10px;
`

export const Label = styled.label<any>`
  display: inline-block;
  font-size: 12px;
  font-weight: 700;
  color: ${({ theme }) => theme.colors.primary};
`

export const Error = styled.span`
  color: ${({ theme }) => theme.colors.error};
  font-size: 12px;
`
